module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    添加表单元素\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "label-width": "150px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "field_title",
      "rules": [{
        required: true,
        message: '请输入标题',
        trigger: 'blur'
      }]
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "身高(cm)"
    },
    on: {
      "change": _vm.fieldTitleChange
    },
    model: {
      value: (_vm.form.field_title),
      callback: function($$v) {
        _vm.$set(_vm.form, "field_title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.field_title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表单元素类型",
      "prop": "form_element",
      "rules": [{
        required: true,
        message: '请选择表单元素',
        trigger: 'change'
      }]
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.ElementChange
    },
    model: {
      value: (_vm.form.form_element),
      callback: function($$v) {
        _vm.$set(_vm.form, "form_element", $$v)
      },
      expression: "form.form_element"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "text"
    }
  }, [_vm._v("单文本框")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "textarea"
    }
  }, [_vm._v("多文本域")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "radio"
    }
  }, [_vm._v("单选按钮")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "checkbox"
    }
  }, [_vm._v("复选框")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "select"
    }
  }, [_vm._v("下拉选择")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "date"
    }
  }, [_vm._v("日期选择")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "time"
    }
  }, [_vm._v("时间选择")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "area"
    }
  }, [_vm._v("地区选择")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "number"
    }
  }, [_vm._v("数字(纯数字)")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "image"
    }
  }, [_vm._v("图片录入(单图)")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.form.options), function(domain, index) {
    return (_vm.form.form_element == 'radio' || _vm.form.form_element == 'checkbox' || _vm.form.form_element == 'select') ? _c('el-form-item', {
      key: domain.key,
      attrs: {
        "label": '选择项' + index,
        "prop": 'options.' + index + '.value',
        "rules": {
          required: true,
          message: '选择项不能为空',
          trigger: 'blur'
        },
        "span": 10
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 15
      }
    }, [_c('el-input', {
      attrs: {
        "width": "20"
      },
      model: {
        value: (domain.value),
        callback: function($$v) {
          _vm.$set(domain, "value", $$v)
        },
        expression: "domain.value"
      }
    })], 1), _vm._v(" "), (index > 1) ? _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeDomain(domain)
        }
      }
    }, [_vm._v("删除")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('div', [_c('imgBox', {
      attrs: {
        "imgUrl": _vm.wximageurl + domain.image_url,
        "inline": ""
      },
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "frm-tips"
    }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：400px * 450px）")]), _vm._v(" "), _c('imgPicker', {
      attrs: {
        "dialog-visible": _vm.imgDialog,
        "sc-status": _vm.isGetImage
      },
      on: {
        "chooseImg": _vm.pickImg,
        "closeImgDialog": _vm.closeImgDialog
      }
    })], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.form.form_element == 'radio' || _vm.form.form_element == 'checkbox' || _vm.form.form_element == 'select') ? _c('el-form-item', [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "circle": ""
    },
    on: {
      "click": _vm.addOption
    }
  }, [_vm._v("增")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "英文标识",
      "prop": "field_name",
      "rules": [{
        required: true,
        message: '请输入英文标识',
        trigger: 'blur'
      }]
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "height 或者 shengao"
    },
    on: {
      "blur": _vm.fieldNameChange
    },
    model: {
      value: (_vm.form.field_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "field_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.field_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片",
      "prop": "image_url"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', [_c('imgBox', {
    attrs: {
      "imgUrl": _vm.wximageurl + _vm.form.image_url,
      "inline": ""
    },
    on: {
      "click": _vm.handleImgBChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：400px * 450px）")]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAction
    }
  }, [_vm._v("保存")])], 1)], 2)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7961b16d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7961b16d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/selfservice/formsettingadd.vue
// module id = 2846
// module chunks = 0